var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCmDetector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m30.5 17.84-.007-3.742c-.144-2.14-4.785-3.859-10.493-3.859-5.8 0-10.5 1.774-10.5 3.962v3.638"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M12.699 20.868c-1.973-.783-3.2-1.88-3.2-3.096 0-2.379 4.701-4.307 10.5-4.307s10.5 1.928 10.5 4.307c0 1.19-1.174 2.267-3.075 3.046"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M12.68 23.208V19.76c0-1.66 3.278-3.004 7.32-3.004 4.043 0 7.32 1.345 7.32 3.004v3.447"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20 20.233c-4.043 0-7.32 1.345-7.32 3.003 0 1.66 3.277 3.003 7.32 3.003s7.32-1.344 7.32-3.003c0-1.658-3.277-3.003-7.32-3.003Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20 22.256c-1.319 0-2.389.44-2.389.98 0 .541 1.07.98 2.389.98s2.389-.439 2.389-.98-1.07-.98-2.389-.98Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  d: "M16.06 27.834c-.028.019-.688.47-.688.998 0 .51.618.96.681 1.005q.002 0 .004.003c.005.004.576.404.576.837 0 .427-.566.817-.575.823M20.057 27.834c-.027.019-.687.47-.687.998 0 .51.618.96.68 1.005l.004.003c.006.004.576.404.576.837 0 .427-.564.817-.574.823M24.056 27.834c-.028.019-.687.47-.687.998 0 .51.617.96.68 1.005l.004.003c.005.004.575.404.575.837 0 .427-.564.817-.573.823"
}))));
export default SvgCmDetector;